var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "8665305_envelope_email_icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 13.75C9.3543 13.75 8.70859 13.5382 8.15781 13.109L0 6.76562V15.625C0 16.6602 0.839453 17.5 1.875 17.5H18.125C19.1605 17.5 20 16.6605 20 15.625V6.76562L11.8438 13.1133C11.293 13.5391 10.6445 13.75 10 13.75ZM0.636328 5.67578L8.92539 12.125C9.55781 12.6172 10.4437 12.6172 11.0762 12.125L19.3652 5.67578C19.7305 5.36328 20 4.88281 20 4.375C20 3.33945 19.1602 2.5 18.125 2.5H1.875C0.839453 2.5 0 3.33945 0 4.375C0 4.88281 0.234766 5.36328 0.636328 5.67578Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.bb86141226f553ff5fe078c9751f02e7.svg";
export { ForwardRef as ReactComponent };